import * as React from "react";

import { Box, Grid } from "@mui/material";

import CustomInput from "../../../../helper-components/input/CustomInput";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { validateRow } from "../../../../helper-functions/validation/objectValidation";
import { addFormToObj, setInsertObjectState, setValue } from "../../../../helper-functions/shared/miscUtils";
import { IS_AUTHOR_VALID, AUTHOR_VALIDATION } from "../../../../helper-functions/validation/authorValidation";

import { getLanguage } from "../../../../config/language/language";
import { AUTHOR_REQUEST_OBJECT } from "../../../../config/constants/Constants";

/**
 * A form to update a author.
 */
export default function AuthorAddForm(props) {
    // Because modals don't re-render if the props' state changes, use a callback.
    const { callback, row: existingRow = {} } = props;

    const object = AUTHOR_REQUEST_OBJECT;
    const validation = AUTHOR_VALIDATION;
    const isValid = IS_AUTHOR_VALID;

    const [row, setRow] = React.useState(addFormToObj(JSON.parse(JSON.stringify(object))));

    // Initialize the temporary row object with existing values.
    React.useEffect(() => {
        const newRow = {
            ...row,
            ...existingRow,

            form: {
                ...row.form,
                ...existingRow.form,
                saved: false // Required to allow editing input fields.
            }
        };

        setInsertObjectState(setRow, newRow);
    }, []);

    /**
     * Executed when typing something into an input field.
     */
    const onChange = (obj, key, value) => {
        const newAuthor = JSON.parse(JSON.stringify(row));
        setValue(newAuthor, key, value);

        validateRow(obj, validation, newAuthor);
        setInsertObjectState(setRow, newAuthor);
    };

    const handleClick = () => {
        if (!isValid(row)) {
            props.showSnackbar({ message: getLanguage().SNACKBAR_ERROR_FORM_INVALID, color: "error" });
            return;
        }

        const options = { row };
        callback(true, options);
    };

    return (
        <Box className="box">
            <Grid container spacing={1}>
                <Grid item xs={6}>
                    <CustomInput name="first_name" row={row} onChange={onChange} label="First name" />
                </Grid>

                <Grid item xs={6}>
                    <CustomInput name="last_name" row={row} onChange={onChange} label="Last name" />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput name="bio" row={row} onChange={onChange} label="Bio" multiline minRows={2} maxRows={5} />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput
                        name="aliases"
                        row={row}
                        onChange={onChange}
                        label="Aliases"
                        placeholder={"John Doe\nJane Doe"}
                        helperText="Other names this person goes by, one per line."
                        multiline
                        minRows={2}
                        maxRows={4}
                    />
                </Grid>

                <Grid item xs={12}>
                    <CustomInput
                        name="exclusions"
                        row={row}
                        onChange={onChange}
                        label="Exclusions"
                        placeholder={"Sponsored by John Doe\nCheck out Jane Doe's new book"}
                        helperText="Phrases to ignore when matching, one per line. Other mentions of the name still count."
                        multiline
                        minRows={2}
                        maxRows={4}
                    />
                </Grid>
            </Grid>

            <CustomButton {...props} title={"Save author"} onClick={handleClick} className="button" fullWidth />
        </Box>
    );
}
